import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'getCertificate'
})
export class GetCertificatePipe implements PipeTransform {

  transform(id_user: any, certificado:any): any {
    const student = certificado.find(item =>{
      if(item.id == id_user){
        return item;
      }
    })
    if(!student){
      return false;
    }
    return student.certificate==0?false:true;
  }

}
